module.exports = __webpack_public_path__ + "img/a1.50a29393.png";